import * as React from 'react';
import { Title } from 'react-admin';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ProjectsChartsComponent from '~screens/Dashboard/screens/ProjectsIIRSA/screens/ProjectCharts/components/ProjectsChartsComponent';
import styles from './styles.module.scss';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ProjectService } from 'config/services/project.service';
import money from '~assets/banknote.svg';
import projects from '~assets/folder-open.svg';
import i18next from 'i18next';
import './i18n';

const Home = () => {
    const initialState = {
        totalCount: 0,
        totalInvestment: 0
    };
    const [state, setState] = useState(initialState);
    const location = useLocation();
    const { id } = useParams();

    const projectService = new ProjectService();


    useEffect(() => {
        getData();
    }, [location.search]);

    const getData = () => {
        // eslint-disable-next-line react/prop-types
        const query = location.search.substring(1);
        const vars = query.split('&');
        let filterObj = {};
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (pair[0] === 'filter') {
                filterObj = JSON.parse(decodeURIComponent(pair[1]));
            }
        }
        let filterQuery = '';
        // eslint-disable-next-line guard-for-in
        for (const key in filterObj) {
            const filterData = filterObj[key];
            if (typeof filterData === 'object' && !Array.isArray(filterData)) {
                for (const filterDataKey in filterData) {
                    filterQuery = `${filterQuery}${key}[${filterDataKey}]=${filterObj[key][filterDataKey]}&`;
                }
            } else {
                filterQuery = `${filterQuery}${key}=${filterObj[key]}&`;
            }
        }
        if (filterQuery) {
            filterQuery = `?${filterQuery.substring(0, filterQuery.length - 1)}`;
            if (id) {
                filterQuery = `${filterQuery}&route_id=${id}`;
            }
        }
        else {
            if (id) {
                filterQuery = `?route_id=${id}`;
            }
        }

        projectService
            .get_projects_list_extra_data(filterQuery)
            .then(res => {
                setState(res.data);
            })
            .catch(() => {
                setState(initialState);
            });
    }

    return (
        <div className={styles.listContainer}>
            <div className={styles.listHeader}>
                <div className={styles.header}>
                    <div className={styles.left}>
                        <div className={styles.firstLine}>
                            {i18next.t('home:welcome')}
                        </div>
                        <div className={styles.title}>
                            {i18next.t('home:title')}
                        </div>
                        <div>
                            <div className={styles.mainParagraph}>
                                {i18next.t('home:description1')}
                            </div>
                            <div className={styles.paragraph}>
                                {i18next.t('home:description2')}
                            </div>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <div className={styles.breadcrumbContainer}>
                            <div className={styles.breadcrumbItem}>
                                <div className={styles.breadcrumbItemIcon}>
                                    <img src={projects} alt="projects" />
                                </div>
                                <div className={styles.breadcrumbItemTitle}>
                                    {i18next.t('home:totalProjects')}
                                </div>
                                <div className={styles.breadcrumbItemValue}>
                                    {state.totalCount || 0}
                                </div>
                            </div>
                            <div className={styles.breadcrumbItem}>
                                <div className={styles.breadcrumbItemIcon}>
                                    <img src={money} alt="money" />
                                </div>
                                <div className={styles.breadcrumbItemTitle}>
                                    {i18next.t('home:totalInvestment')}
                                </div>
                                <div className={styles.breadcrumbItemValue}>
                                    {state.totalInvestment || 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.listContent}>
                <div className={styles.list}>
                    <ProjectsChartsComponent />
                </div>
            </div>
        </div>
    );
};

export default Home;
